import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, handleSessionExpiredError } from '../../utils/auth';
import { PaginatedRequestType } from '../../types/pagination';
import { GetPostulationsParams, Postulation, RequiredFile } from './types';

// Define a service using a base URL and expected endpoints
export const postulationsApi = createApi({
  reducerPath: 'postulationsApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    // List
    getPostulations: builder.query<
      PaginatedRequestType<Postulation>,
      GetPostulationsParams
    >({
      query: (params) => ({
        url: '/applications',
        params,
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    // Required files
    getRequiredFiles: builder.query<RequiredFile[], void>({
      query: () => ({
        url: '/required-files/files',
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    uploadFile: builder.mutation<void, FormData>({
      query: (body) => ({
        method: 'POST',
        url: `/required-files/upload`,
        body,
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    deleteFile: builder.mutation<void, string | number>({
      query: (fileId) => ({
        method: 'DELETE',
        url: `/required-files/files/${fileId}`,
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    // Detail
    getPostulationDetail: builder.query<Postulation, string | number>({
      query: (postulationId) => ({
        url: `/applications/${postulationId}`,
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPostulationsQuery,
  useGetRequiredFilesQuery,
  useGetPostulationDetailQuery,
  useUploadFileMutation,
  useDeleteFileMutation,
} = postulationsApi;
